import React, { useEffect } from 'react';
import Rotas from './routes/route';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    // Listener para evento de token expirado
    const handleTokenExpired = (event) => {
      const message = event.detail?.message || "Sua sessão expirou. Por favor, faça login novamente.";
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    };

    // Adicionar listener
    window.addEventListener('tokenExpired', handleTokenExpired);

    // Limpar listener ao desmontar
    return () => {
      window.removeEventListener('tokenExpired', handleTokenExpired);
    };
  }, []);

  return (
    <>
      <Rotas />
      <ToastContainer />
    </>
  );
}

export default App;
